/** The tabs of the page of a vendor return in Atelier, in the order it shows them (`?tab=`). */
export const vendorReturnTabs = ["lines", "details"] as const;
export type VendorReturnTab = (typeof vendorReturnTabs)[number];
